import type { ObjectType } from './types';

const ITEM_ROUTES: Record<ObjectType, string> = {
  solution: '/app/data/reseni/reseni',
  product: '/app/data/reseni/vyrobky',
  unit: '/app/nastaveni/super-admin/databaze/jednotky',
  biblio: '/app/data/obecne/biblio',
  propertydefinition: '/app/data/reseni/vlastnosti',
  technicalreportitem: '/app/data/reseni/polozky-zpravy',
  professionbond: '/app/data/reseni/profesni-vazby',
  setpropertydefinition: '/app/data/reseni/sady-vlastnosti',
  settechnicalreportitem: '/app/data/reseni/sady-zprav',
};

export const approvalItemUrl = (type: ObjectType, id: string): string | null => {
  const route = ITEM_ROUTES[type];
  if (!route || !id) return null;
  const encodedId = encodeURIComponent(id);
  return type === 'solution' || type === 'product'
    ? `${route}/${encodedId}`
    : `${route}?id=${encodedId}`;
};
